// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oTMV","comment":"styles_comment__2ZCCA"};